<template>
  <div style="background-color: #edf4fc;">
    <div style="padding: 0.1rem;">
      <div class="news" style="text-align: center;margin-top: 0;">国家线简介</div>
      <p class="science-press-p">考研国家线是教育部依据硕士生培养目标，结合年度招生计划、生源情况及总体初试成绩情况，确定报考统考、MBA及法律硕士专业学位考生进入复试的基本要求标准，其中包括应试科目总分要求和单科分数要求。应届本科毕业生和非应届毕业生实行统一的进入复试基本分数要求。</p>
      <p class="science-press-p">根据报考学校所在省份，国家线分为A区和B区（A类和B类），A区的总分比B区高10分。</p>
      <p class="science-press-p">A区包括省份：北京、天津、河北、山西、辽宁、吉林、黑龙江、上海、江苏、浙江、安徽、福建、江西、山东、河南、湖北、湖南、广东、重庆、四川、陕西等21省 (市)。</p>
      <p class="science-press-p">B区包括省份：内蒙古、广西、海南、贵州、云南、西藏、甘肃、青海、宁夏、新疆等10省(区)。</p>
      <p class="science-press-p">
        从2002年开始，教育部门为了让一些高水平大学自己选择人才培养，允许自划线学校根据报考自己学校考生的情况和招生计划来划定考研复试分数线，而不用参考国家统一划定的分数线，当然分数线要上报教育部备案。
        <a href="#two" class="divcolor">
          <span style="font-size: 20px;">( 34所自划线院校复试线 )</span>
        </a>
      </p>
    </div>

    <div style="margin: 0.1rem;">
      <div class="news">研究生历年国家线</div>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 0.1rem;">
        <el-tab-pane label="2015" name="2015" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2016" name="2016" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2017" name="2017" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2018" name="2018" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2019" name="2019" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2020" name="2020" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2021" name="2021" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2022" name="2022" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2023" name="2023" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2024" name="2024" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2025" name="2025" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2026" name="2026" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2027" name="2027" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2028" name="2028" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="2029" name="2029" style="text-align: center;">
          <a :href="link" target="_blank" class="divcolor">{{ name }}</a>
          <br>
          <el-image :src="picture">
            <div slot="error" v-loading="loading"></div>
          </el-image>
          <div style="padding: 0.1rem;text-align: center;" v-if="name === '' && picture === ''">
            <p class="science-press-p">待录入.........</p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div style="margin: 0.1rem;margin-bottom: 0;" id="two">
      <div class="news">34所自划线院校复试线</div>
      <div style="font-size: 20px;height: 40px;line-height: 40px;padding-left: 0.1rem;">根据学校名称和年级搜索复试线信息：</div>
      <div style="padding: 0.1rem;overflow: hidden;padding-top: 0;padding-bottom: 0;">
        <div style="float: left;font-size: 18px;">学校：</div>
        <div style="float: left;width: 93%;padding-top: 2px;">
          <el-radio-group v-model="school" @change="changeSelect">
            <el-radio label="北京大学">北京大学</el-radio>
            <el-radio label="清华大学">清华大学</el-radio>
            <el-radio label="中国人民大学">中国人民大学</el-radio>
            <el-radio label="北京航空航天大学">北京航空航天大学</el-radio>
            <el-radio label="北京理工大学">北京理工大学</el-radio>
            <el-radio label="中国农业大学">中国农业大学</el-radio>
            <el-radio label="北京师范大学">北京师范大学</el-radio>
            <el-radio label="南开大学">南开大学</el-radio>
            <el-radio label="天津大学">天津大学</el-radio>
            <el-radio label="大连理工大学">大连理工大学</el-radio>
            <el-radio label="东北大学">东北大学</el-radio>
            <el-radio label="吉林大学">吉林大学</el-radio>
            <el-radio label="哈尔滨工业大学">哈尔滨工业大学</el-radio>
            <el-radio label="复旦大学">复旦大学</el-radio>
            <el-radio label="同济大学">同济大学</el-radio>
            <el-radio label="上海交通大学">上海交通大学</el-radio>
            <el-radio label="南京大学">南京大学</el-radio>
            <el-radio label="东南大学">东南大学</el-radio>
            <el-radio label="浙江大学">浙江大学</el-radio>
            <el-radio label="中国科学技术大学">中国科学技术大学</el-radio>
            <el-radio label="厦门大学">厦门大学</el-radio>
            <el-radio label="山东大学">山东大学</el-radio>
            <el-radio label="武汉大学">武汉大学</el-radio>
            <el-radio label="华中科技大学">华中科技大学</el-radio>
            <el-radio label="湖南大学">湖南大学</el-radio>
            <el-radio label="中南大学">中南大学</el-radio>
            <el-radio label="中山大学">中山大学</el-radio>
            <el-radio label="华南理工大学">华南理工大学</el-radio>
            <el-radio label="四川大学">四川大学</el-radio>
            <el-radio label="重庆大学">重庆大学</el-radio>
            <el-radio label="电子科技大学">电子科技大学</el-radio>
            <el-radio label="西安交通大学">西安交通大学</el-radio>
            <el-radio label="西北工业大学">西北工业大学</el-radio>
            <el-radio label="兰州大学">兰州大学</el-radio>
          </el-radio-group>
        </div>

      </div>

      <div style="padding: 0.1rem;overflow: hidden;padding-top: 0;">
        <div style="float: left;font-size: 18px;">年级：</div>
        <div style="float: left;width: 93%;padding-top: 2px;">
          <el-radio-group v-model="grade" @change="changeSelect">
            <el-radio :label="2015">2015</el-radio>
            <el-radio :label="2016">2016</el-radio>
            <el-radio :label="2017">2017</el-radio>
            <el-radio :label="2018">2018</el-radio>
            <el-radio :label="2019">2019</el-radio>
            <el-radio :label="2020">2020</el-radio>
            <el-radio :label="2021">2021</el-radio>
            <el-radio :label="2022">2022</el-radio>
            <el-radio :label="2023">2023</el-radio>
            <el-radio :label="2024">2024</el-radio>
            <el-radio :label="2025">2025</el-radio>
            <el-radio :label="2026">2026</el-radio>
            <el-radio :label="2027">2027</el-radio>
            <el-radio :label="2028">2028</el-radio>
            <el-radio :label="2029">2029</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div style="padding: 0.1rem;text-align: center;" v-if="name34 !== ''">
        <a :href="link34" target="_blank" class="divcolor">{{ name34 }} {{ grade }} 年复试线</a>
        <br>
        <br>
        <el-image :src="picture34">
          <div slot="error" v-loading="loading"></div>
        </el-image>
      </div>

      <div style="padding: 0.1rem;text-align: center;" v-if="name34 === ''">
        <p class="science-press-p">待录入.........</p>
      </div>
    </div>

  </div>
</template>

<script>
// 按需导入 API 接口
import { selectLine } from '@/api/lineAPI'
import { selectLine34 } from '@/api/line34API'

export default {
  name: 'Lines',
  data() {
    return {
      activeName: '2024',
      Lines: [],
      picture: '',
      link: '',
      name: '',
      Line34s: [],
      picture34: '',
      link34: '',
      name34: '',
      school: '北京大学',
      grade: 2024,
      loading: true
    }
  },
  created() {
    this.LineFind()
    this.Line34Find()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    handleClick(tab, event) {
      this.picture = ''
      this.link = ''
      this.name = ''
      for (let i = 0; i < this.Lines.length; i++) {
        if (this.Lines[i].grande === Number(tab.paneName)) {
          this.picture = this.Lines[i].picture
          this.link = this.Lines[i].link
          this.name = this.Lines[i].name
        }
      }
    },
    async LineFind() {
      this.picture = ''
      this.link = ''
      this.name = ''
      const { data: res } = await selectLine()
      this.Lines = res.data
      for (let i = 0; i < this.Lines.length; i++) {
        if (this.Lines[i].grande === 2024) {
          this.picture = this.Lines[i].picture
          this.link = this.Lines[i].link
          this.name = this.Lines[i].name
        }
      }
    },
    async Line34Find() {
      const { data: res } = await selectLine34()
      this.Line34s = res.data
      this.picture34 = ''
      this.link34 = ''
      this.name34 = ''
      for (let i = 0; i < this.Line34s.length; i++) {
        if (this.Line34s[i].grande === this.grade && this.Line34s[i].name === this.school) {
          this.picture34 = this.Line34s[i].picture
          this.link34 = this.Line34s[i].link
          this.name34 = this.Line34s[i].name
        }
      }
    },
    changeSelect() {
      this.picture34 = ''
      this.link34 = ''
      this.name34 = ''
      for (let i = 0; i < this.Line34s.length; i++) {
        if (this.Line34s[i].grande === this.grade && this.Line34s[i].name === this.school) {
          this.picture34 = this.Line34s[i].picture
          this.link34 = this.Line34s[i].link
          this.name34 = this.Line34s[i].name
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.divcolor {
  font-size: 25px;
}
.divcolor:hover {
  color: #B8860B;
}
p {
  margin-block-start: 0.05rem;
  margin-block-end: 0.05rem;
}
.science-press-p {
  font-size: 20px;
  text-indent: 0.3rem;
  text-align:justify;
  line-height: 1.6;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
}
.news {
  margin: 0.1rem 0.1rem 0.1rem 0.05rem;
  font-size: 25px;
  font-weight: 700;
}
/deep/ .el-tabs__item {
  font-size: 16px;
}
/deep/ .el-radio__input {
  display: none;
  font-size: 18px;
}
/deep/ .el-radio {
  margin-right: 0.13rem;
  margin-bottom: 0.09rem;
}
.el-radio-group {
  padding-top: 0.02rem;
  vertical-align: bottom;
}
/deep/ .el-radio__label {
  padding-left: 0;
  font-size: 18px;
}
</style>
